module.exports = __webpack_public_path__ + "static/img/1000000435_blue.5f25bf24.jpg";